// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"eb81788c","453":"8c7b2c9b"}[chunkId] + ".chunk.js";
};